import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { useInputGroupClassName } from '../../legacy/InputGroup';
import { FSMaskProp } from '../../types';
import css from './index.module.scss';
import { InputSize, InputVariant } from './types';

export interface TextInputOutlineProps {
  children?: React.ReactNode;
  /**
   * For element identity and testing purposes. Defaults to 'text-input-wrapper'
   */
  testId?: string;
  /**
   * Size of the input. Default is 'medium'
   */
  size?: InputSize;
  /**
   * Type of input. Default is 'fill'.
   */
  variant?: InputVariant;
  /**
   * If true, the input will not be able to be selected or clicked.
   */
  disabled?: boolean;
  /**
   * If true, the input will be marked as invalid
   */
  invalid?: boolean;
  /**
   * If true, the outline will show a focused state
   */
  focused?: boolean;
  /**
   * FS Mask rule
   */
  fsMask?: FSMaskProp;
  /**
   * When true, the input's width will be 100%
   */
  fullWidth?: boolean;
  /**
   * An optional className that is passed to the input wrapper.
   */
  className?: string;
}

export const TextInputOutline: React.FC<TextInputOutlineProps> = ({
  focused = false,
  children,
  disabled = false,
  fsMask,
  fullWidth = false,
  invalid = false,
  size = 'medium',
  testId = 'text-input-wrapper',
  variant = 'fill',
  className,
}) => {
  const inputGroupItemClassName = useInputGroupClassName();

  return (
    <div
      data-component="TextInputInner"
      data-testid={testId}
      className={classNames(
        fsMask,
        css.inputWrapper,
        css[size],
        css[variant],
        className,
        {
          [css.focused]: focused,
          [css.disabled]: disabled,
          [css.invalid]: invalid,
          [css.fullWidth]: fullWidth,
        },
        inputGroupItemClassName,
      )}
    >
      {children}
    </div>
  );
};

TextInputOutline.displayName = 'TextInputOutline';
